import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsOverviewPageController extends AbstractRsvpDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.workflows = this.injector.get('Workflows');
        this.navService = this.injector.get('NavService');

        this._initSettings();
    }

    _initSettings() {
        this.enableMigrateToNewYear = _.get(this.userStore, 'state.company.settings.rsvps.enable_year_migration', false);
    }

    _handleRsvpSelect() {
        super._handleRsvpSelect();

        const workflows = this.workflows.getWorkflows('rsvps::details')
            .filter(workflow => {
                return this.workflows.shouldShow(this.rsvp, workflow) && (this.rsvp.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight');
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.rsvp, this);
                };

                return workflow;
            });

        this.navService.overrideMainSideNavActions(workflows);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/overview-controller.js